export interface Formula {
  id: string
  name: string
  audience: 'pro' | 'prive'
  headline: string
  from: string
  guests: string
  includes: string[]
  image?: string
  featured?: boolean
}

export const formulas: Formula[] = [
  {
    id: 'cocktail',
    name: 'Cocktail dînatoire',
    audience: 'pro',
    headline: 'Le tour du monde en bouchées, servi debout.',
    from: '18 € / pers.',
    guests: '30 à 250 convives',
    includes: [
      '8 pièces salées par personne',
      'Verrines, quesadillas, mini-tourtes',
      'Mise en place et service inclus',
      'Vaisselle et nappage',
    ],
    image: 'https://cdn.magicpatterns.com/uploads/dLWunSuwSbBZHunctg9Z2N/1000001280.jpg',
    featured: true,
  },
  {
    id: 'buffet',
    name: 'Buffet froid & plateaux',
    audience: 'pro',
    headline: 'Séminaires, inaugurations, pauses déjeuner.',
    from: '14 € / pers.',
    guests: '15 à 120 convives',
    includes: [
      'Plateaux de mini-sandwichs',
      'Planches fromages & fruits',
      'Livraison sur site',
      'Option pause café',
    ],
    image: 'https://cdn.magicpatterns.com/uploads/gjFJV4kQR3c8easbydbJNb/aac76c87-ca11-491f-a64d-47e6acd7f5e8-1_all_1159.jpg',
  },
  {
    id: 'truck',
    name: 'Le food-truck chez vous',
    audience: 'prive',
    headline: 'Mariages, anniversaires, fêtes de village.',
    from: '22 € / pers.',
    guests: '50 à 300 convives',
    includes: [
      'Le camion sur votre lieu',
      'Tourtes cuites sur place',
      'Choix de 3 recettes du monde',
      '2 personnes en service',
    ],
    image: 'https://cdn.magicpatterns.com/uploads/wVqTRsNcF6f5fBnhRnb7vw/1000000075.jpg',
  },
]

export interface Step {
  title: string
  text: string
}

export const process: Step[] = [
  { title: 'Votre demande', text: 'Date, lieu, nombre de convives, budget indicatif.' },
  { title: 'Proposition sous 48 h', text: 'Un menu sur mesure et un devis détaillé, sans engagement.' },
  { title: 'Dégustation', text: 'Pour les événements de plus de 80 convives, sur rendez-vous.' },
  { title: 'Le jour J', text: 'On arrive 2 h avant, on installe, on sert, on repart propre.' },
]
